
















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getRestaurantOrders} from '@/ts/orders/get-orders';
import {putOrder} from '@/ts/orders/put-order';
import {getRestaurant} from '@/ts/restaurants/get-restaurant';
import {assignDelivery} from '@/ts/deliveries/assign-delivery';
// Import variables
import {OrderOptions, SelectDelivery, SuccessfulAction, SuccessfullySelected} from '@/ts/variables';

export default {
    name: 'TheTableRestaurantOrders',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {
        status: Object,
    },
    data() {
        return {
            options: [],
        };
    },
    methods: {
        sort(temp) {
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            this.$store.dispatch('setLoadingOn');
            getRestaurantOrders(this.$route.params.id).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        refreshItem(event, id) {
            if (event === 'DELIVERING') {
                this.addDelivery(id);
                return;
            }
            this.$store.dispatch('setLoadingOn');
            putOrder(id, this.$route.params.id, event).then(() => {
                getRestaurantOrders(this.$route.params.id).then(() => {
                    for (const item of this.$store.getters.response) {
                        this.$set(this.status, item.id, item.attributes.status);
                    }
                });
            }).finally(() => {
                this.$store.dispatch('setLoadingOff');
            });
        },
        // TODO: Fix at a later time
        addDelivery(orderId) {
            getRestaurant(this.$route.params.id).then((response: any) => {
                const result = {};
                const deliveryUsers = response.users.filter((item) => item.relationships.roles.includes('Delivery'));
                for (const user of deliveryUsers) {
                    result[user.id] = user.attributes.first_name + ' ' + user.attributes.last_name;
                }
                this.$swal.fire({
                    title: SelectDelivery,
                    input: 'select',
                    inputOptions: result,
                    inputPlaceholder: 'Изберете доставчик',
                    showCancelButton: true,
                    inputValidator: (value) => {
                        return new Promise((resolve) => {
                            if (value !== '') {
                                resolve();
                            } else {
                                resolve('Трябва да изберете доставчик');
                            }
                        });
                    },
                }).then((item) => {
                    if (item.hasOwnProperty('value')) {
                        assignDelivery(orderId, this.$route.params.id, item.value, 'DELIVERING').then(() => {
                            getRestaurantOrders(this.$route.params.id).then(() => {
                                for (const datum of this.$store.getters.response) {
                                    this.$set(this.status, datum.id, datum.attributes.status);
                                }
                            });
                            this.$swal.fire(SuccessfulAction, SuccessfullySelected, 'success');
                        });
                    }
                });
            });
        },
    },
    created() {
        this.options = OrderOptions;
    },
};
